export default {
  googleAuthorizeTerms: "Diese App wird ab dem 10. März 2023 nicht mehr unterstützt. Bitte installieren Sie die neue Version von {googleAppName}."
};

// @key: @#@"googleAuthorizeTerms"@#@ @source: @#@"This app will not be supported after Mar 10th, 2023. Please install our new version of {googleAppName}."@#@
